import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { fetchEventFacts } from 'dash-front/facts/actions/facts';
import { compose, defaultProps } from 'recompose';

class FactsView extends React.PureComponent {
    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(fetchEventFacts(2511282, 'postMatch'));
    }

    render() {
        let { facts } = this.props;

        return (
            <table>
                <tr>
                    <td>Type</td>
                    <td>Message</td>
                </tr>

                {facts.map(f => (
                    <tr key={f.type}>
                        <td>{f.type}</td>
                        <td>{f.message}</td>
                    </tr>
                ))}
            </table>
        );
    }
}

export default compose(
    defaultProps({
        eventId: 2511282,
        type: 'postMatch'
    }),
    connect(
        (state, { eventId, type }) => {
            return {
                facts: _.get(state, `query.entities['${eventId}/facts/${type}']`, [])
            };
        },
        dispatch => ({ dispatch })
    )
)(FactsView);



/** WEBPACK FOOTER **
 ** ../src/dash/front/facts/FactsView.js
 **/